// extracted by mini-css-extract-plugin
export default {"wrapper":"OtQKJ3","select":"QO86Js","arrow-down":"tymR4I","arrowDown":"tymR4I","ltr":"KibjIz","rtl":"lElvG_"};